export const realtorData = {
  email: 'fabians@bidata.cl',
  // email: 'contacto@accionpanal.com',
};
